import { DrawerBase } from '../../../core/abstraction/DrawerBase';

export class BackgroundLandscapeDrawer extends DrawerBase {
  constructor(applications) {
    super();
    this.applications = applications;
  }

  setBackgroundFirstLayer() {

  }

  setBackgroundSecondLayer() {

  }

  setBackgroundPlantsAnimation() {

  }

  execute(root) {

  }
}
